<template>
  <div>
    <div class="listado" v-if="items && items.length > 0">
      <b-table
        ref="carreras"
        :fields="camposTabla"
        :items="items"
        :current-page="currentPage"
        :per-page="perPage"
        @row-selected="onRowSelected"
        select-mode="single"
        selectable
        class="table-hover table-sm"
      >
        <template v-slot:head(comparador)>
          <FontAwesomeIcon icon="server" />
        </template>
        <!-- CELDAS-->
        <!--Comparador-->
        <template v-slot:cell(comparador)>
          <input type="checkbox" aria-label="Checkbox_compare" />
        </template>
        <!-- Institucion-->
        <template v-slot:cell(institucion)="data">
          <div v-b-tooltip.hover :title="data.value.nombre">
            {{ data.value.nombreCorto }}
          </div>
        </template>
        <!-- Acreditacion-->
        <template v-slot:cell(acreditacion)="data">
          <div>
            <span>{{ data.value }}</span>
          </div>
        </template>
        <!-- Carrera-->
        <template v-slot:cell(carrera)="data">
          <div class="text-negro">{{ data.value }}</div>
        </template>
        <!-- Jornada-->
        <template v-slot:cell(jornada)="data">
          <Jornada :jornada="data.value" />
        </template>
        <!-- Postulacion-->
        <template v-slot:cell(postulacion)="data">
          {{ textoPostulacion(data.value) }}
          <!--<PostulacionTP :postulacion="data.value" />-->
        </template>
        <!-- Contacto-->
        <template v-slot:cell(contacto)="data">
          <span
            @click="onRowSelected(data.value)"
            v-b-tooltip.hover
            title="Solicita que te envíen más información sobre esta carrera"
          >
            <FontAwesomeIcon icon="envelope" />
          </span>
        </template>
        <!--CELDAS-->
      </b-table>
    </div>
    <b-pagination
      v-if="items && items.length > 0"
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="perPage"
      class="col-md-4 mx-auto px-0"
      align="center"
    ></b-pagination>
  </div>
</template>

<script>
import FormatoMonetario from "@/utils/FormatoMonetario.js";
import Busqueda from "@/utils/Busqueda.js";
import PostulacionTP from "@/components/generales/iconos/PostulacionTP";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faServer, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faServer, faEnvelope);
import AñosAcreditacion from "@/components/generales/iconos/AniosAcreditacion";
import Jornada from "@/components/generales/iconos/Jornada";
import Gratuidad from "@/components/generales/iconos/Gratuidad";
import { MensajesDeCarga, ModalContacto } from "@/utils/BusesDeEventos.js";
import MixinArancelMatricula from "@/mixins/FormatearArancelMatricula.js";
export default {
  name: "VistaTabla",
  props: {
    listadoCarreras: { type: Array }
  },
  components: {
    FontAwesomeIcon,
    AñosAcreditacion,
    PostulacionTP,
    Jornada,
    Gratuidad
  },
  mixins: [MixinArancelMatricula],
  data() {
    return {
      camposTabla: [
        //{ key: "comparador", label: "" },
        {
          key: "region",
          label: "Región",
          tdClass: "text-left font-weight-bold text-nowrap",
          sortable: true
        },
        {
          key: "institucion",
          label: "Institución",
          sortable: true,
          tdClass: "text-left font-weight-bold"
        },
        {
          key: "acreditacion",
          sortable: true,
          label: "Acreditación",
          tdClass: "text-nowrap"
        },
        //{ key: "gratuidad", sortable: true, label: "Gratuidad" },
        { key: "sede", sortable: true, tdClass: "text-left" },
        { key: "carrera", sortable: true, tdClass: "text-left" },
        { key: "arancel", sortable: true, tdClass: "text-right text-nowrap" },
        { key: "jornada", sortable: true, label: "Modalidad" },
        { key: "postulacion", sortable: true, label: "Postulación" },
        { key: "contacto", label: "Contáctame" }
      ],
      datos: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 8,
      verFicha: true
    };
  },
  watch: {
    listadoCarreras() {
      this.totalRows = this.listadoCarreras.length;
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.listadoCarreras.length;
  },
  computed: {
    items() {
      let items = [];
      let lc = this.listadoCarreras;
      for (let carrera of lc) {
        items.push({
          region:
            carrera.datos.jornada === "A_DISTANCIA"
              ? "-"
              : this.limpiarNombreRegion(carrera.sede.region),
          institucion: {
            nombre: carrera.institucion.nombre,
            nombreCorto: carrera.institucion.nombreCorto
          },
          acreditacion: this.textoAcreditacion(
            carrera.institucion.acreditado,
            carrera.institucion.acreditacion.anios,
            carrera.institucion.observacionAcreditacionCNA
          ),
          //gratuidad: carrera.institucion.gratuidad,
          sede:
            carrera.datos.jornada === "A_DISTANCIA"
              ? "Aula Virtual"
              : carrera.sede.nombre,
          carrera: carrera.datos.nombre,
          arancel: this.textoArancel(
            carrera.datos.tipoMoneda,
            carrera.datos.arancelAnual
          ),
          jornada: carrera.datos.jornada,
          postulacion: carrera.datos.tipoPostulacion,
          contacto: {
            modal: true,
            codigoIntitucion: carrera.institucion.codigo,
            codigoSede: carrera.sede.codigo,
            codigoCarrera: carrera.datos.codigo
          },
          modal: false
        });
      }
      return items;
    }
  },
  methods: {
    toggleBusy() {
      this.isBusy = !this.isBusy;
    },
    textoLateral(data) {
      let text = data === 1 ? "año" : "años";
      return ` ${data} ${text}`;
    },
    textoAcreditacion(acreditado, anios, observacionCNA) {
      let text = "";
      if (acreditado) {
        if (anios === 0) {
          text = "Acreditada";
        } else {
          text = this.textoLateral(anios);
        }
      } else if (observacionCNA) {
        text = "Bajo Tutela";
      } else {
        text = "No Acreditada";
      }
      return text;
    },
    textoArancel(tipoMoneda, monto) {
      return this.formatearArancelMatricula(monto, tipoMoneda);
    },
    textoPostulacion(val) {
      if (val) {
        return val;
      } else {
        return "No Disponible";
      }
    },
    onRowSelected(value) {
      if (value.modal) {
        this.verFicha = false;
        ModalContacto.$emit("contactame", value);
      } else if (this.verFicha && value[0]) {
        let idInst = value[0].contacto.codigoIntitucion;
        let idCarrea = value[0].contacto.codigoCarrera;
        this.$router.push({
          name: "FichaCarreraU",
          params: {
            idInstitucion: idInst,
            codigoCarrera: idCarrea,
            origen: "BuscadorCU"
          }
        });
      } else {
        this.verFicha = true;
        this.$refs.carreras.clearSelected();
      }
    },
    limpiarNombreRegion(region) {
      return Busqueda.limpiarNombreRegionSimble(region);
    },
    arregloInstitucionesPaginado(arreglo) {
      this.datos = arreglo;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/buscadorCU/VistaTabla.vue